var styles = {"message-row":"styles_message-row__1H-d4 p2","messageRow":"styles_message-row__1H-d4 p2"};

export default styles;
//# sourceMappingURL=styles.css.js.map
